import $ from 'jquery';

import {
  getElement,
  SITE_BODY,
  SITE_NAVIGATION_BUTTON,
  SITE_NAVIGATION,
  OPEN_CLASS
} from './site-variables';

const siteNavigation = () => {
  console.log('siteNavigation init 888');
  let siteBody = getElement(SITE_BODY);
  let navigationButtonElement = getElement(SITE_NAVIGATION_BUTTON);
  let navigationElement = getElement(SITE_NAVIGATION);

  navigationButtonElement.click(() => {
    siteBody.toggleClass(OPEN_CLASS);
    navigationButtonElement.toggleClass('close');
  });
};

export default siteNavigation;
